"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = exports.getSelectedState = exports.datePickerCSS = exports.validateDate = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var shared_1 = require("../DateModules/shared");
var Calendar_1 = require("../DateModules/Calendar");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var useDatePicker_1 = require("../DateModules/useDatePicker");
var useKeyboardAccesibility_1 = require("../DateModules/useKeyboardAccesibility");
var validateDate = function (_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate, date = _a.date;
    if (minDate && maxDate && (0, shared_1.getDateFromDateOrNow)(minDate) >= (0, shared_1.getDateFromDateOrNow)(maxDate)) {
        console.warn("minDate must be less than maxDate");
    }
    if (date) {
        if (minDate && (0, shared_1.getDateFromDateOrNow)(minDate) > date) {
            console.warn("date must be greater than or equal to minDate");
        }
        if (maxDate && (0, shared_1.getDateFromDateOrNow)(maxDate) < date) {
            console.warn("date must be less than or equal to maxDate");
        }
    }
};
exports.validateDate = validateDate;
var datePickerCSS = function (numberOfMonths, selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  width: ", "px;\n  line-height: initial;\n  padding: 8px;\n  border: 0;\n"], ["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  width: ", "px;\n  line-height: initial;\n  padding: 8px;\n  border: 0;\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.white, dark: design_system_foundations_1.darkTheme.color.primeBlue }), numberOfMonths * 334); };
exports.datePickerCSS = datePickerCSS;
var getSelectedState = function (_a) {
    var isSelected = _a.selected;
    return (isSelected ? shared_1.SelectedState.SELECTED : undefined);
};
exports.getSelectedState = getSelectedState;
exports.DatePicker = (0, react_1.forwardRef)(function (_a, ref) {
    var date = _a.date, minDate = _a.minDate, maxDate = _a.maxDate, _b = _a.initialMonth, initialMonth = _b === void 0 ? 'NOW' : _b, _c = _a.testId, testId = _c === void 0 ? 'date-picker' : _c, className = _a.className, onDateSelected = _a.onDateSelected, rest = __rest(_a, ["date", "minDate", "maxDate", "initialMonth", "testId", "className", "onDateSelected"]);
    (0, exports.validateDate)({ minDate: minDate, maxDate: maxDate, date: date });
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var locale = (0, design_system_foundations_1.useLocalizationContext)().locale;
    var handleDateSelected = (0, react_1.useCallback)(function (_a) {
        var newDate = _a.date, selectable = _a.selectable;
        if (selectable) {
            onDateSelected(newDate);
        }
    }, [onDateSelected]);
    var selected = date ? [date] : [];
    var _d = (0, useDatePicker_1.useDatePicker)({
        date: date || (0, shared_1.getDateFromDateOrNow)(initialMonth),
        minDate: minDate,
        maxDate: maxDate,
        monthsToDisplay: 1,
        selected: selected,
        onDateSelected: handleDateSelected,
    }), calendars = _d.calendars, getDateProps = _d.getDateProps, getBackProps = _d.getBackProps, getForwardProps = _d.getForwardProps, hoveredDate = _d.hoveredDate, onDateMouseOver = _d.onDateMouseOver, onDateMouseOut = _d.onDateMouseOut;
    var onAccesibleKeyDown = (0, useKeyboardAccesibility_1.useKeyboardAccesibility)({
        handleChange: onDateSelected,
        currentValue: date !== null && date !== void 0 ? date : new Date(),
        minDate: minDate,
        maxDate: maxDate,
    }).onKeyDown;
    var calendar = calendars[0];
    var handleKeyDown = function (event) {
        onAccesibleKeyDown(event);
    };
    return (react_1.default.createElement("div", __assign({}, rest, { role: "group", onKeyDown: handleKeyDown, "data-testid": testId, ref: ref, className: (0, css_1.cx)(className, (0, exports.datePickerCSS)(1, selectedTheme), 'ds-date-picker') }),
        react_1.default.createElement("div", { className: (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                  display: flex;\n                  position: relative;\n                "], ["\n                  display: flex;\n                  position: relative;\n                "]))) },
            react_1.default.createElement(Calendar_1.CalendarBackButton, { getButtonProps: function (props) { return getBackProps(__assign(__assign({}, props), { calendars: calendars })); } }),
            react_1.default.createElement(Calendar_1.CalendarForwardButton, { getButtonProps: function (props) { return getForwardProps(__assign(__assign({}, props), { calendars: calendars })); } }),
            react_1.default.createElement(Calendar_1.Month, { key: "".concat(calendar.month, "-").concat(calendar.year) },
                react_1.default.createElement(Calendar_1.MonthHeader, { month: (0, shared_1.dateToToLongMonthString)(calendar.firstDayOfMonth, locale), year: calendar.year.toString() }),
                react_1.default.createElement(Calendar_1.DayHeader, { dayAbbreviations: (0, shared_1.getDayAbbreviations)(locale) }),
                calendar.weeks.map(function (week, weekIndex) {
                    var key = "".concat(calendar.year, "-").concat(calendar.month, "-").concat(weekIndex);
                    return (react_1.default.createElement(Calendar_1.Week, { key: key, week: week, getDateProps: getDateProps, getSelectedState: exports.getSelectedState, getHoverState: function (_a) {
                            var dateToCheck = _a.date;
                            return hoveredDate && dateToCheck.getTime() === hoveredDate.getTime() ? shared_1.HoverState.HOVERED : undefined;
                        }, onDateMouseOver: onDateMouseOver, onDateMouseOut: onDateMouseOut }));
                })))));
});
exports.DatePicker.displayName = 'DatePicker';
var templateObject_1, templateObject_2;
